<template>
    <div class="shop-content">

        <div class="shop-content-head">
            <div class="shop-content-result">
                <b>{{ products.length }}</b>
                <span>{{ $trans('main.Result') }}</span>
            </div>

            <button type="button" class="btn btn-sm text-underline ml-auto">
                {{ $trans('main.Clear filter') }}
            </button>

            <el-select
                class="m-2"
                placeholder="Select"
                v-model="selectedOrderBy"
                size="large">
                <el-option
                    v-for="(orderItem, key) in orderItems"
                    :key="key"
                    :label="orderItem"
                    :value="key"
                />
            </el-select>

            <div class="shop-view" role="group">
                <button
                    type="button"
                    class="btn btn-unstyled shop-view-btn"
                    id="listView"
                    aria-pressed="false"
                >
                    <i class="bi bi-list-task text-lg" aria-hidden="true"></i>
                </button>
                <button
                    type="button"
                    class="btn btn-unstyled shop-view-btn is-active"
                    id="gridView"
                    aria-pressed="true"
                >
                    <i class="bi bi-grid text-lg" aria-hidden="true"></i>
                </button>
            </div>

            <button type="button" class="btn btn-unstyled text-xl d-lg-none filter-menu-btn">
                <i class="bi bi-funnel"></i>
            </button>
        </div>

        <div class="shop-content-inner">
            <div class="loading-wrapper shop-loader" :class="{'d-none': !isLoading}">
                <ArmeniansLoader :aria-label="$trans('mobile.Loading')"/>
            </div>
            <ProductItem v-for="product in products" :product="product" :key="product.id"/>
        </div>
    </div>
</template>

<script>
import ProductItem from "./ProductItem.vue";
import ArmeniansLoader from "../ArmeniansLoader.vue";

export default {
    name: 'SContent',
    components: {ProductItem, ArmeniansLoader},

    props: ['products', 'isLoading', 'selectedOrderBy', 'orderItems']
}
</script>
